import { ReactElement, useState } from "react";
import {Swiper, SwiperSlide} from 'swiper/react';
import { Autoplay, Grid, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight, faFileImage, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

import { getPartnersList} from "apis/distribution";

import "assets/css/distribution.scss";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import PartnersListProp from "types/partners";

interface PartnersProps {
  children: (result: UseQueryResult<PartnersListProp[]>) => ReactElement;
}

interface PartnersHocProps extends PartnersProps {
  strType: string;
}

type ParentProps = {
  strType: string;
};

const PartnersHoc = ({ children, strType }: PartnersHocProps) => {
  //console.log("strType :: " + strType );

  let paramData = {
    strType: strType,
    intPage: 1,
    intPageSize: 100
  };

  return children(useQuery({
    queryKey: ['Partners', paramData],
    queryFn: getPartnersList,
    staleTime: 1000 * 10, // 10초 후 상함. 즉, 10초 동안 신선함.
  }));
};

const Partners = ({strType}: ParentProps) => {
  const [intRows, setIntRows] = useState<number>(strType === "P" ? 2 : 1);
  let boolLoop = strType === "C" ? true : false;  
          
  return (
    <div className="partners">
      <PartnersHoc strType={strType}>
        {({ data, isError, isLoading }) => {
          if (isLoading) {
            return <div className='loading-spinner'><FontAwesomeIcon icon={faFileImage} /> Loading...</div>;
          }

          if (isError || !data) {
            return <div className='error-message'><FontAwesomeIcon icon={faTriangleExclamation} /> Error loading data</div>;
          }

          if(strType === "P") {
            return (
              <>           
              <div className={`partners-gallery`} >
                <Swiper 
                  slidesPerView={'auto'}
                  spaceBetween={5}
                  speed={1000}
                  autoplay={{     // 자동 재생
                      delay: 3000, // 지연 시간 (한 슬라이더에 머물리는 시간)
                      disableOnInteraction: false // 마우스 제어 이후 자동 재생을 막을지 말지
                  }}
                  modules={[Grid, Pagination, Navigation, Autoplay]}
                  grid={{
                    rows: intRows,
                    fill: "row",
                  }}
                  loop={boolLoop}
                  navigation = {true}
                  pagination = {true}
                  
                  className='partners-slide'
                >
                {data.map((item: PartnersListProp, index: number) => (
                  <SwiperSlide className='partners-item' key={index}>
                    <img src={item.BProductImg} alt={item.BProductCompany} className="partner-image"/>
                  </SwiperSlide>
                ))}
  
                </Swiper>
              </div>
              </>
            );
          }else if(strType === "S"){
            return (
              <>           
              <div className="container" >
                <div className='container-img-grid col4 fixed-ratio'>
                  {data.map((item: PartnersListProp, index: number) => (
                    <div className="img-style" key={index}>
                      <div className="img-inner">
                        <img src={item.BProductImg} alt={item.BProductCompany} className="partner-image"/>
                      </div>
                      <div className="img-text">
                        {item.BProductName}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              </>
            );
          }else{
            return (
              <>           
              <div className="container" >
                <div className='container-img-grid col4'>
                  {data.map((item: PartnersListProp, index: number) => (
                    <div className="img-style" key={index}>
                      <div className="img-inner">
                        <img src={item.BProductImg} alt={item.BProductCompany} className="partner-image"/>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              </>
            );
          }
          
        }}
      </PartnersHoc>
    </div>
  );
};

export default Partners;
